import React, { useContext, useEffect, useRef } from "react";
import BseContext from "../context/BseContext";
import { FiCheckCircle, FiExternalLink } from "react-icons/fi";

/**
 * BSE Login Card - Admin side only
 * Login to BSE Portal: connects via API (getPassword per APIFileStructure.pdf)
 * Once connected, stays connected - no logout. Auto-refreshes before expiry.
 * Auto-login: when admin visits dashboard and session expired, connects automatically (no credentials/OTP needed).
 */
export default function BseLoginCard() {
  const { isBseConnected, loginBSE, openPortal, loading, error } =
    useContext(BseContext);
  const hasAutoLoggedIn = useRef(false);

  // Auto-login when admin visits dashboard and session is expired (e.g. after hours)
  // Backend uses .env credentials - no user input or OTP needed
  useEffect(() => {
    if (!isBseConnected && !loading && !hasAutoLoggedIn.current) {
      hasAutoLoggedIn.current = true;
      loginBSE();
    }
  }, [isBseConnected, loading, loginBSE]);

  return (
    <div className="d-flex align-items-center gap-3 flex-wrap">
      {!isBseConnected ? (
        <button
          className="btn bse-login-btn"
          onClick={() => loginBSE()}
          disabled={loading}
          style={{
            background: "#ffffff",
            color: "#14b8a6",
            border: "1px solid #b3e5e1",
            borderRadius: "8px",
            padding: "10px 24px",
            fontWeight: "600",
            fontSize: "15px",
            transition: "all 0.2s ease",
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
          }}
          onMouseEnter={(e) => {
            if (!loading) {
              e.currentTarget.style.borderColor = "#14b8a6";
              e.currentTarget.style.backgroundColor = "#f0fdfa";
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = "#b3e5e1";
            e.currentTarget.style.backgroundColor = "#ffffff";
          }}
        >
          {loading ? (
            <>
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
                style={{ color: "#14b8a6" }}
              />
              Connecting...
            </>
          ) : (
            <>Login to BSE Portal</>
          )}
        </button>
      ) : (
        <>
          <span
            className="badge d-flex align-items-center gap-2"
            style={{
              background: "#d1fae5",
              color: "#059669",
              padding: "8px 14px",
              borderRadius: "6px",
              fontSize: "13px",
              fontWeight: "600",
            }}
          >
            <FiCheckCircle size={16} style={{ color: "#10b981" }} />
            BSE Connected
          </span>
          <button
            className="btn btn-sm"
            onClick={openPortal}
            style={{
              background: "#f0fdfa",
              color: "#14b8a6",
              border: "1px solid #b3e5e1",
              borderRadius: "6px",
              padding: "6px 14px",
              fontWeight: "600",
              fontSize: "13px",
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
            }}
            title="Open BSE StAR MF Portal"
          >
            <FiExternalLink size={14} />
            Open BSE Portal
          </button>
        </>
      )}

      {error && (
        <div
          className="p-2 rounded"
          style={{
            background: "#fef2f2",
            color: "#dc2626",
            fontSize: "13px",
            maxWidth: 400,
          }}
        >
          {error}
        </div>
      )}
    </div>
  );
}
